export default __webpack_public_path__ + "static/media/julie testa.587853fd.jpg";